import { Component, Injectable,Inject, Input, OnInit, TemplateRef } from "@angular/core";
import { navItems } from "./../../_nav";
import { AuthenticationService } from "./../../_services/authentication.service";
import { CONFIGCONSTANTS } from "../../config/app-constants";
import * as moment from "moment";
import { Router, ActivatedRoute, Event as NavigationEvent, NavigationStart } from "@angular/router";
import { filter, map, mergeMap } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "../../_services/language.service";
import { Subscription } from "rxjs";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Title } from "@angular/platform-browser";
import { SettingsService } from "../../_services/settings-service";
import { DOCUMENT } from "@angular/common";
@Component({
  selector: "app-dashboard",
  templateUrl: "./default-layout.component.html"
})
@Injectable({
  providedIn: 'root'
})
export class DefaultLayoutComponent implements OnInit {
  modalRef: BsModalRef;
  private subscription: Subscription;
  public navItems = navItems;
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement = document.body;
  private Language = localStorage.getItem("lan") || "en";
  appTitle: any = CONFIGCONSTANTS.siteName;
  DefaultfavImg: String = "assets/img/brand/logo_updated.png";
  DefaultlogoImg: String = "assets/img/brand/logo_icon.png";
  
  favImg: any = this.DefaultfavImg;
  logoImg: any = this.DefaultlogoImg;

  referralIcon: String = "assets/img/referral-icon.png";
  Inventory_Management : string = "assets/img/Inventory.svg"
  referralIconWhite: String = "assets/img/referral-icon-white.png";
  supplierManagement : string = 'assets/img/supplier-management-icon.svg';
  inquiryManagement : string = 'assets/img/inquiry-side-con.svg';
  appointmentManagement : string = 'assets/img/appointment-side-icon.svg';
  notificationManagement : string = 'assets/img/Notification-Management.svg';
  billingManagement : string = "assets/img/billing-side-icon.svg"
  public currYear = moment().format("YYYY");
  fullname: String = "";
  settings: any;
  currentState: string;
  prevState: string;
  prevUrl: string;
  languageOption: boolean = CONFIGCONSTANTS.languageOption;

  daysLeft:any;
  subscriptionValid:boolean = false;
  subscriptionOver:boolean = false;
  expiredOn:any;
  noSubscription:boolean = true;
  isSuperAdmin:boolean = false;
  showClass: boolean = false;
  assignedCredits:any;
  remainingCredits:any;
  subscriptionString:string = '';
  logodata:any;
  logodetail: any;
  favdetails:any;
  toplogo : any;
  sitetitle:any;

  constructor(
    private modalService: BsModalService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private languageSwitcher: LanguageService,
    private titleService: Title,
    private settingService:SettingsService,
    private setting:SettingsService,
    @Inject(DOCUMENT) private _document: HTMLDocument
    
  
  ) {
    // set default language if language option is disabled
    this.Language = !this.languageOption ? "en" : this.Language;

    this.changes = new MutationObserver(mutations => {
      this.sidebarMinimized = document.body.classList.contains(
        "sidebar-minimized"
      );
    });

    this.changes.observe(<Element>this.element, {
      attributes: true
    });

    this.subscription = this.languageSwitcher.getLanguage().subscribe(lan => {
      this.translate.setDefaultLang(lan);
      this.translate.use(lan);
      this.Language = lan;
    });
    this.languageSwitcher.changeLanguage(this.Language);
  }

  async ngOnInit() {
    this.logodata = this.setting.getSettingsImageDataURL().subscribe(Response=>{
      this.logodetail = Response.data.logo ||'assets/img/brand/logo_updated.png';
      this.favdetails = Response.data.favicon ||'assets/img/brand/logo_icon.png';
      this.sitetitle  = Response.data.site_name || 'Medify';
      
      this.fullname = localStorage.getItem("fullName");
      this.settings = localStorage.getItem("settings");
  
      this.logoImg = this.logodetail;

      this._document.getElementById('defaultlogo').setAttribute('src', this.logodetail);
      this._document.getElementById('appFavicon').setAttribute('href', this.favdetails);
      this._document.getElementById('defaultFavlogo').setAttribute('src', this.favdetails);
      this._document.getElementById('appTitle').innerText = this.sitetitle;
      
      }
    )

    this.isSuperAdmin = this.authenticationService.checkRoleSuperAdmin();    
    this.daysLeft = this.authenticationService.getSubscriptionEndDate().daysLeft;
    this.assignedCredits = this.authenticationService.getSubscriptionEndDate().assignedCredits;
    this.remainingCredits = this.authenticationService.getSubscriptionEndDate().remainingCredits;
    this.expiredOn = moment(this.daysLeft).format('DD-MM-YYYY');
    this.checkSubscriptionValidity();  
  }

  public changeLanguage(lan: string) {
    this.languageSwitcher.changeLanguage(lan);
    this.translate.use(lan);
  }

  onLogout() {
    localStorage.clear();
    this.decline();
    this.authenticationService.logout();
    this.router.navigate(['/login']).then(() => { 
      window.location.reload();
    });
  }

  toggleMenu() {
    const element = document.getElementsByTagName('body');
    element[0].classList.remove("sidebar-show");
    
    this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationStart) {
        if (event.url.startsWith('/master-logs/')) {
          this.showClass = true;
        } else {
          this.showClass = false;
        }
      }
    });

  }
  /* Open any Modal Popup */
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-md' });
  }
  decline(): void {
    this.modalRef.hide();
  }

checkSubscriptionValidity() {
  if (this.isSuperAdmin) {
    return; // No need to proceed if user is a super admin
  }
  
  if (this.daysLeft === null || this.daysLeft === undefined || this.daysLeft === '') {
    this.subscriptionOver = false;
    this.noSubscription = true;
  } else {
    const daysLeft = this.getDaysLeft(this.daysLeft);
    this.subscriptionValid = daysLeft >= 1;
    this.subscriptionOver = !this.subscriptionValid;
    this.noSubscription = false;
    this.subscriptionString = (daysLeft === 1) ? `${daysLeft} day left` : `${daysLeft} days left`;
  }
}

  getDaysLeft(endDate:any){
    let currentDateTime = new Date().getTime();
    let endDateTime = new Date(endDate).getTime();
    //converting miliseconds to days
    let daysLeft = (endDateTime - currentDateTime)/86400000;
    return Math.ceil(daysLeft);    
  }

  toggleMasterLog() {
    this.showClass = !this.showClass
  }
}
